module.exports = __webpack_public_path__ + "img/B1.03ecaec8.png";